module.exports = __webpack_public_path__ + "img/jack_promo.51a11cb0.png";